import { render, staticRenderFns } from "./ItemListItemAddLayout.vue?vue&type=template&id=d63b870e&scoped=true"
import script from "./ItemListItemAddLayout.vue?vue&type=script&lang=js"
export * from "./ItemListItemAddLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63b870e",
  null
  
)

export default component.exports